import axios from "axios";
import { Url } from "../Api/Api";
import {
  getAccessToken,
  getUserId,
  getUserType,
} from "../hooks/useLocalStorage";
import { useCallback } from "react";

export const useLogout = () => {
  const logoutUser = useCallback(async ({ navigation }) => {
    const userType = getUserType();
    const token = getAccessToken();
    const userId = getUserId();

    const endPoint =
      userType === "admin" || userType === "superadmin"
        ? Url.AdminLogout
        : Url.StudentLogout;

    try {
      await axios.post(endPoint, userId, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const fromAdmin = sessionStorage.getItem("fromAdmin");

      if (fromAdmin === "1") {
        // student simulation logout
        sessionStorage.removeItem("student_token");
        sessionStorage.removeItem("student_role");
        sessionStorage.removeItem("student_group_id");
        sessionStorage.removeItem("student_user_id");
        sessionStorage.removeItem("fromAdmin");

        navigation();

        setTimeout(() => {
          window.close();
        }, 300);
      } else {
        // normal admin logout
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("group_id");
        localStorage.removeItem("user_id");

        navigation();
      }
    } catch (error) {
      console.error("Logout failed:", error.response?.data || error.message);
    }
  }, []);

  return { logoutUser };
};
